import { useEffect, useRef, useState } from 'react';

// Paginate after filtering; keep full data available to totals and bulk actions.
export default function useListPagination(items, resetKey = '', pageSize = 20) {
  const [selection, setSelection] = useState({ key: resetKey, page: 1 });
  const topRef = useRef(null);
  const scrollRequested = useRef(false);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const page = selection.key === resetKey ? Math.min(selection.page, totalPages) : 1;

  useEffect(() => {
    if (selection.key !== resetKey || selection.page !== page) {
      setSelection({ key: resetKey, page });
    }
  }, [selection, resetKey, page]);

  useEffect(() => {
    if (scrollRequested.current) {
      scrollRequested.current = false;
      topRef.current?.scrollIntoView({
        behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'auto' : 'smooth',
        block: 'start',
      });
    }
  }, [page, resetKey]);

  return {
    page, pageSize, totalPages, total: items.length, topRef,
    items: items.slice((page - 1) * pageSize, page * pageSize),
    onPageChange: (nextPage) => {
      scrollRequested.current = true;
      setSelection({ key: resetKey, page: Math.max(1, Math.min(nextPage, totalPages)) });
    },
  };
}
